import { createApiSlice } from "@common";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {CRUD_PERSONAL_DOCUMENTS, HCM_PERSONAL_DOWNLOAD_DATA , HCM_PERSONAL_UPLOAD_DATA } from "@routes";
import axios from "axios";
// Define the API config array
const apiConfig = [
  {
    name: "addPersonalDocument",
    method: "post",
    url: CRUD_PERSONAL_DOCUMENTS,
    stateKey: "message",
  },
  {
    name: "getPersonalDocument",
    method: "get",
    url: CRUD_PERSONAL_DOCUMENTS,
    stateKey: "data",
  },
  {
    name: "updatePersonalDocument",
    method: "put",
    url: CRUD_PERSONAL_DOCUMENTS,
    stateKey: "message",
  },
  {
    name: "deletePersonalDocument",
    method: "delete",
    url: CRUD_PERSONAL_DOCUMENTS,
    stateKey: "message",
  },
  {
    name: "getPersonalDocumentDetailsById",
    method: "get",
    url:CRUD_PERSONAL_DOCUMENTS,
    stateKey: "details",
  },
  // {
  //   name: "uploadPersonalDocumentFile",
  //   method: "post",
  //   url: HCM_PERSONAL_UPLOAD_DATA,
  //   stateKey: "message",
  // },
];
export const uploadPersonalDocumentFile = createAsyncThunk(
  "prospect/uploadPersonalDocumentFile",
  async (formData, { rejectWithValue }) => {
    try {
      const res = await axios.post(HCM_PERSONAL_UPLOAD_DATA, formData, {
        withCredentials: true,
        responseType: "blob",
      });

      const contentType = res.headers["content-type"];

      // Backend returned failed Excel
      if (
        contentType?.includes(
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        )
      ) {
        const url = globalThis.URL.createObjectURL(
          new Blob([res.data])
        );

        const link = document.createElement("a");

        link.href = url;
        link.setAttribute("download", "FailedPersonalDocuments.xlsx");

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        globalThis.URL.revokeObjectURL(url);

        return {
          message: "Some prospects failed. Failed records have been downloaded.",
        };
      }

      // Backend returned JSON response
      const text = await res.data.text();
      const data = JSON.parse(text);

      return data;
    } catch (err) {
      let errorData = err?.response?.data;

      // Error response can also be a Blob
      if (errorData instanceof Blob) {
        try {
          const text = await errorData.text();
          errorData = JSON.parse(text);
        } catch {
          // Keep original errorData if it is not JSON
        }
      }

      return rejectWithValue(errorData);
    }
  }
);
export const downloadPersonalDocumentData = createAsyncThunk(
  "prospect/downloadPersonalDocumentData",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      console.log("Downloading prospect data with params:", data);
      await axios
        .get(HCM_PERSONAL_DOWNLOAD_DATA , {
          params: data,
          withCredentials: true,
          responseType: "blob",
        })
        .then((res) => {
          const url = globalThis.URL.createObjectURL(new Blob([res.data]));

          const link = document.createElement("a");

          link.href = url;

          link.setAttribute("download", "PersonalDocuments.xlsx");

          document.body.appendChild(link);

          link.click();
        });
    } catch (err) {
      return rejectWithValue(err.response);
    }
  }
);
// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    data: [],
    details: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    [downloadPersonalDocumentData.pending]: (state) => {
      state.loading = true;
    },

    [downloadPersonalDocumentData.fulfilled]: (state) => {
      state.loading = false;
    },

    [downloadPersonalDocumentData.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },
    [uploadPersonalDocumentFile.pending]: (state) => {
      state.loading = true;
    },

    [uploadPersonalDocumentFile.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
    },

    [uploadPersonalDocumentFile.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage =
        action?.payload?.message ||
        action?.payload?.data?.message;
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "prospect",
  apiConfig,
  customReducers,
);
const prospectSlice = slice;

// Export the slice's reducer
export default prospectSlice.reducer;

// Export thunks
export const {
  addPersonalDocument,
  getPersonalDocument,
  updatePersonalDocument,
  deletePersonalDocument,
  getPersonalDocumentDetailsById,
  // uploadPersonalDocumentFile
} = thunks;

// Export actions
export const { rowSelect } = actions;
